import { render, staticRenderFns } from "./MarkTheoryPaper.vue?vue&type=template&id=6bc87e2a&scoped=true&"
import script from "./MarkTheoryPaper.vue?vue&type=script&lang=js&"
export * from "./MarkTheoryPaper.vue?vue&type=script&lang=js&"
import style0 from "./MarkTheoryPaper.vue?vue&type=style&index=0&id=6bc87e2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc87e2a",
  null
  
)

export default component.exports